import { useState } from "react";
import SectionHeading from "./SectionHeading";

export const HOMEFAGS = [
  {
    q: "吃瓜资讯的“事件梳理”和普通爆料有什么不同？",
    a: "普通爆料往往只呈现单一结论或单方说法，而我们会把事件的前因后果、多方立场与争议点完整呈现，并尽量标注哪些信息已获多源交叉验证、哪些仍存在疑点，让你在掌握全貌的前提下自行判断。",
  },
  {
    q: "“完整时间线”是如何保证客观准确的？",
    a: "时间线中的每一个节点，都来自公开可查的官方声明、权威报道或经核验的一手资料，我们会标注关键时间点与来源性质。对于时间或细节存在出入的信息，我们会在条目中明确提示，而不是自行补全。",
  },
  {
    q: "“背后真相 / 深度解析”会不会主观臆测？",
    a: "深度解析部分会明确区分“已证实事实”与“合理推断”。所有推断都以公开信息为基础、以分析为方法，并在标题与正文中清晰标注，尽可能减少未经证实的臆测，把推论逻辑完整呈现给你。",
  },
  {
    q: "我可以投稿或提供线索吗？",
    a: "当然欢迎。你可以通过页面底部或“追瓜提醒”区域的联系方式联系我们，提供你认为值得梳理的话题线索。收到线索后我们会先做事实核查与信源比对，确认可验证后再立项制作专题。",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section
      id="faq"
      className="w-full bg-background-100 scroll-mt-24"
      aria-label="常见问题"
    >
      <div className="mx-auto w-full max-w-4xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          icon="ri-question-line"
          kicker="常见问题"
          title="关于吃瓜资讯，你可能想问"
          desc="我们整理了几个读者最常问的问题。仍有疑问？欢迎通过联系方式与我们聊聊。"
        />

        <div className="mt-10 space-y-3">
          {HOMEFAGS.map((item, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  isOpen
                    ? "border-primary-200 bg-background-50"
                    : "border-background-200 bg-background-100 hover:border-background-300"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : idx)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  >
                    <span className="flex items-center gap-3 text-sm font-semibold text-foreground-900 md:text-base">
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                          isOpen
                            ? "bg-primary-500 text-background-50"
                            : "bg-secondary-100 text-secondary-700"
                        }`}
                      >
                        {String(idx + 1).padStart(2, "0")}
                      </span>
                      {item.q}
                    </span>
                    <i
                      className={`${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      } shrink-0 text-xl text-foreground-400 transition-transform`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4 pl-[4.5rem] pr-6 text-sm leading-relaxed text-foreground-700 md:px-6 md:pl-[4.75rem]">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}